export default "/images/Pro-17a.png?5f3965dca5d9900266eb9c1f80f3326b";